/**
 * Nhac nen Giang sinh — nut bat/tat noi o goc trai duoi, CHI o nhom trang
 * Santa Spins (layout/theme.liquid quyet dinh qua snippets/la-santa.liquid).
 *
 * Vi sao la NUT chu khong tu phat: trinh duyet (Chrome, Safari, iPhone) CHAN
 * phat am thanh khi khach chua bam gi — luat cua trinh duyet, theme khong vuot
 * duoc. Phat o "lan cham dau tien" thi khach dang o van phong / nua dem giat
 * minh va thoat trang. Nut: khach chu dong bat.
 *
 * Nhung dieu co y:
 *   - Am luong 0.25, tang dan 1,5 giay (chu shop dan "vua du nhe nhang").
 *   - preload="none": khong tai 2,26 MB cho nguoi khong nghe.
 *   - Nho lua chon trong sessionStorage: da bat thi sang trang Santa khac phat
 *     tiep. Trinh duyet chan tu phat sau khi chuyen trang thi chay lai o lan
 *     cham ke tiep — hop le vi khach da chu dong bat truoc do.
 *   - Tam dung khi tab an, quay lai thi phat tiep.
 */
(() => {
  const nut = document.querySelector('[data-nhac-nut]');
  const am = document.querySelector('[data-nhac-am]');
  if (!nut || !am) return;

  const MUC = 0.25;
  const KHOA = 'santa-nhac';
  let dangPhat = false, mo = 0;

  const nho = (v) => { try { sessionStorage.setItem(KHOA, v); } catch (e) {} };
  const daBat = () => { try { return sessionStorage.getItem(KHOA) === 'bat'; } catch (e) { return false; } };

  const hien = () => {
    nut.setAttribute('aria-pressed', dangPhat ? 'true' : 'false');
    nut.setAttribute('aria-label', dangPhat ? 'Pause Christmas music' : 'Play Christmas music');
    nut.classList.toggle('is-phat', dangPhat);
  };

  const tangDan = () => {
    cancelAnimationFrame(mo);
    const bd = performance.now();
    const buoc = (t) => {
      const k = Math.min(1, (t - bd) / 1500);
      am.volume = MUC * k;
      if (k < 1 && dangPhat) mo = requestAnimationFrame(buoc);
    };
    mo = requestAnimationFrame(buoc);
  };

  const phat = () => {
    am.volume = 0;
    return am.play().then(() => { dangPhat = true; hien(); tangDan(); }).catch(() => { dangPhat = false; hien(); throw 0; });
  };
  const dung = () => { am.pause(); dangPhat = false; hien(); };

  nut.addEventListener('click', () => {
    if (dangPhat) { dung(); nho('tat'); }
    else { phat().then(() => nho('bat')).catch(() => {}); }
  });

  // Da bat o trang truoc: thu phat tiep; bi chan thi doi lan cham ke tiep.
  if (daBat()) {
    phat().catch(() => {
      const cho = () => { if (daBat() && !dangPhat) phat().catch(() => {}); };
      addEventListener('pointerdown', cho, { once: true, capture: true });
    });
  }

  let doTabAn = false;
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && dangPhat) { doTabAn = true; dung(); }
    else if (!document.hidden && doTabAn) { doTabAn = false; phat().catch(() => {}); }
  });

  // Bong bong "Tap for music": hien sau 3s, an sau 5s, MOT LAN moi phien, va
  // khong hien neu khach da bat nhac — goi y chu khong nhac di nhac lai.
  const GOI = 'santa-nhac-goi';
  let daGoi = false; try { daGoi = sessionStorage.getItem(GOI) === '1'; } catch (e) {}
  if (!daGoi && !daBat()) {
    setTimeout(() => {
      if (dangPhat) return;
      nut.classList.add('is-goi');
      try { sessionStorage.setItem(GOI, '1'); } catch (e) {}
      setTimeout(() => nut.classList.remove('is-goi'), 5000);
    }, 3000);
  }
  nut.addEventListener('click', () => nut.classList.remove('is-goi'));

  hien();
})();
